import { useState } from 'react';
import { IPastVitals, Item } from '../../api/fetchPastVitalsByPtOid';
import LabVitalsHistoricalTable from './LabVitalsTable';
import { PastVisitSearchBar } from './PastVisitSearchBar';

export const sortKeyvitalsPastVisits = (
    filteredVitals: IPastVitals[] | undefined,
    keyVitals: string[],
) => {
    const keyvitals = filteredVitals?.filter((v) => keyVitals!.includes(v.id!));

    const nonKeyVitals = filteredVitals?.filter((v) => !keyVitals!.includes(v.id!));

    return [...(keyvitals ?? []), ...(nonKeyVitals ?? [])];
};

enum ACTIVE_TAB {
    LATEST = 'latest',
    ALL_READINGS = 'all-readings',
}

export const HistoricalLabVitalsContent: React.FC<{
    closeMe?: () => void;
    fData: Item[];
    vitalSearch: string;
    setSearchInput: (input: string) => void;
    maxCount: number;
    headingText?: string;
    keyVitals?: string[];
    toggleKeyVital?: (vitalId: string) => Promise<void>;
    onRequestMR?: () => Promise<void>;
    patientId: string;
}> = (props) => {
    const { headingText = 'Historical Test Results' } = props;
    const [activeTab, setActiveTab] = useState<ACTIVE_TAB>(ACTIVE_TAB.LATEST);

    return (
        <div className="flex flex-1 flex-col w-full overflow-hidden bg-darwin-neutral_new-50">
            <div className="bg-white px-16 pt-12 border-b border-darwin-neutral-100">
                <div className="flex items-center justify-between py-12">
                    <div className="flex items-center space-x-16">
                        {props.closeMe && (
                            <div
                                onClick={props.closeMe}
                                className="flex items-center justify-center w-16 h-16 cursor-pointer"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                    className="fill-darwin-neutral-1000 w-16 h-16"
                                >
                                    <path d="M447.1 256c0 13.25-10.76 24.01-24.01 24.01H83.9l132.7 126.6c9.625 9.156 9.969 24.41 .8125 33.94c-9.156 9.594-24.34 9.938-33.94 .8125l-176-168C2.695 268.9 .0078 262.6 .0078 256S2.695 243.2 7.445 238.6l176-168C193 61.51 208.2 61.85 217.4 71.45c9.156 9.5 8.812 24.75-.8125 33.94l-132.7 126.6h340.1C437.2 232 447.1 242.8 447.1 256z" />
                                </svg>
                            </div>
                        )}
                        <span className="font-700 text-16">{headingText}</span>
                    </div>
                    {/* {props.onRequestMR && (
                        <RequestRecordsBt
                            text="Request via whatsapp"
                            className="font-700 text-darwin-accent-bright-blue-800 px-16 py-8 border border-darwin-accent-bright-blue-800 rounded-8"
                            onClick={props.onRequestMR}
                            icon={
                                <svg
                                    width="10"
                                    height="14"
                                    viewBox="0 0 10 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1.34375 12C1.34375 12.2285 1.52148 12.4062 1.75 12.4062H8.25C8.45312 12.4062 8.65625 12.2285 8.65625 12V4.6875H6.625C6.16797 4.6875 5.8125 4.33203 5.8125 3.875V1.84375H1.75C1.52148 1.84375 1.34375 2.04688 1.34375 2.25V12ZM1.75 0.625H5.93945C6.37109 0.625 6.77734 0.802734 7.08203 1.10742L9.39258 3.41797C9.69727 3.72266 9.875 4.12891 9.875 4.56055V12C9.875 12.9141 9.13867 13.625 8.25 13.625H1.75C0.835938 13.625 0.125 12.9141 0.125 12V2.25C0.125 1.36133 0.835938 0.625 1.75 0.625ZM5.60938 10.9844H5.58398C5.58398 11.3398 5.33008 11.5938 4.97461 11.5938C4.64453 11.5938 4.36523 11.3398 4.36523 10.9844V8.39453L3.57812 9.18164C3.34961 9.43555 2.96875 9.43555 2.74023 9.18164C2.48633 8.95312 2.48633 8.57227 2.74023 8.31836L4.56836 6.49023C4.79688 6.26172 5.17773 6.26172 5.40625 6.49023L7.23438 8.31836C7.48828 8.57227 7.48828 8.95312 7.23438 9.18164C7.00586 9.43555 6.625 9.43555 6.39648 9.18164L5.60938 8.39453V10.9844Z"
                                        fill="#215FFF"
                                    />
                                </svg>
                            }
                        />
                    )} */}
                </div>
                <div>
                    <button
                        className={`font-700 px-16 py-10 text-darwin-neutral_new-800 border-b-2 ${
                            activeTab === ACTIVE_TAB.LATEST
                                ? 'text-darwin-accent-bright-blue-800 border-darwin-accent-bright-blue-800 '
                                : 'border-white'
                        }`}
                        onClick={() => {
                            setActiveTab(ACTIVE_TAB.LATEST);
                        }}
                    >
                        Latest
                    </button>
                    <button
                        className={`font-700 px-16 py-10 text-darwin-neutral_new-800 border-b-2 ${
                            activeTab === ACTIVE_TAB.ALL_READINGS
                                ? 'text-darwin-accent-bright-blue-800 border-darwin-accent-bright-blue-800 '
                                : 'border-white'
                        }`}
                        onClick={() => {
                            setActiveTab(ACTIVE_TAB.ALL_READINGS);
                        }}
                    >
                        All readings
                    </button>
                </div>
            </div>
            <div className="space-y-16 rounded-8 bg-white p-16 m-24 h-full overflow-hidden flex flex-col">
                <div className="flex rounded-8 items-center space-x-8 bg-white border border-darwin-neutral-100 px-8 py-8 rounded-4 w-200">
                    <PastVisitSearchBar input={props.vitalSearch} setInput={props.setSearchInput} />
                </div>
                <LabVitalsHistoricalTable
                    fData={props.fData}
                    columnCount={activeTab === ACTIVE_TAB.ALL_READINGS ? props.maxCount : 3}
                    keyVitals={props.keyVitals}
                    toggleKeyVital={props.toggleKeyVital}
                    patientId={props.patientId}
                />
            </div>
        </div>
    );
};
